/** 名号设置 / 个人战绩 / 屠榜殿堂 接口。 */
import { API_BASE } from './api';
import { canonicalJSON } from './canonical';
import type { BoardMode } from '../core/types';
import type { ClientIdentity } from './identity';

function toHex(buf: ArrayBuffer): string {
  return Array.from(new Uint8Array(buf), (b) =>
    b.toString(16).padStart(2, '0')).join('');
}

function nonce(): string {
  const b = new Uint8Array(8);
  crypto.getRandomValues(b);
  return toHex(b.buffer);
}

/** 设置名号：HMAC 签名载荷 {token,name,nonce}。 */
export async function setMyName(
  id: ClientIdentity, name: string,
): Promise<void> {
  if (!id.secret) throw new Error('missing signing secret');
  const body = { token: id.token, name, nonce: nonce() };
  const key = await crypto.subtle.importKey(
    'raw', new TextEncoder().encode(id.secret),
    { name: 'HMAC', hash: 'SHA-256' }, false, ['sign'],
  );
  const sig = toHex(await crypto.subtle.sign(
    'HMAC', key, new TextEncoder().encode(canonicalJSON(body)),
  ));
  const r = await fetch(`${API_BASE}/me/name`, {
    method: 'POST',
    headers: { 'content-type': 'application/json', 'x-signature': sig },
    body: JSON.stringify(body),
  });
  if (!r.ok) {
    let detail = 'set name failed';
    try { detail = String((await r.json()).error ?? detail); } catch { /* */ }
    throw new Error(detail);
  }
}

export interface HistoryRow {
  date: string;
  mode: BoardMode;
  score: number;
  kills: number;
  time: number;
  level: number;
  evolutions: number;
  cause: string;
}

/** 个人战绩历史。 */
export async function fetchMyScores(id: ClientIdentity): Promise<HistoryRow[]> {
  const r = await fetch(`${API_BASE}/me/scores`, {
    headers: { Authorization: `Bearer ${id.token}` },
  });
  if (!r.ok) throw new Error('history failed');
  return (await r.json()) as HistoryRow[];
}

export interface SlayerRow {
  id: number;
  date: string;
  mode: BoardMode;
  aiId: string;
  version: string;
  slayerName: string;
  rank: number;
}

/** 屠榜者殿堂。 */
export async function fetchSlayers(): Promise<SlayerRow[]> {
  const r = await fetch(`${API_BASE}/slayers`);
  if (!r.ok) throw new Error('slayers failed');
  return (await r.json()) as SlayerRow[];
}
